/**
 * Chat Service
 * Handles chat and notification-related API calls
 */
import BaseApiService from '../base/BaseApiService';
import type { ChatRoom, ChatMessage, Notification } from '@app-types';

class ChatService extends BaseApiService {
  /**
   * Get all chat rooms
   */
  async getChatRooms(): Promise<{ success: boolean; data: ChatRoom[] }> {
    return this.get<{ success: boolean; data: ChatRoom[] }>('/chat/rooms');
  }

  /**
   * Get messages for a specific chat room
   */
  async getChatMessages(roomId: number): Promise<{ success: boolean; data: ChatMessage[] }> {
    return this.get<{ success: boolean; data: ChatMessage[] }>(`/chat/rooms/${roomId}/messages`);
  }

  /**
   * Get notifications for the current user
   */
  async getNotifications(
    limit: number = 20
  ): Promise<{ success: boolean; data: { notifications: Notification[]; total: number } }> {
    return this.get<{ success: boolean; data: { notifications: Notification[]; total: number } }>(
      `/notifications?limit=${limit}`
    );
  }

  /**
   * Get unread notification count
   */
  async getUnreadNotificationCount(): Promise<{ success: boolean; data: { count: number } }> {
    return this.get<{ success: boolean; data: { count: number } }>('/notifications/unread-count');
  }

  /**
   * Mark a notification as read
   */
  async markNotificationAsRead(notificationId: number): Promise<{ success: boolean }> {
    return this.put<{ success: boolean }>(`/notifications/${notificationId}/read`);
  }
}

export const chatService = new ChatService();
export default chatService;
